import { InjectionToken } from '@angular/core';

/** Base URL de l'API Laravel (ex. `http://localhost:8080/api`). */
export const API_BASE_URL = new InjectionToken<string>('API_BASE_URL');
